import { BrushFilter } from './brushFilter';
import { brushYRegion } from './brushYHighlight';
export function BrushYFilter(options) {
    return BrushFilter(Object.assign(Object.assign({ hideY: true }, options), { brushRegion: brushYRegion }));
}
//# sourceMappingURL=brushYFilter.js.map